// extracted by mini-css-extract-plugin
export var container = "_ab-0";
export var error = "_ab-9";
export var label = "_ab-5";
export var light = "_ab-6";
export var md = "_ab-3";
export var sm = "_ab-2";
export var thin = "_ab-8";
export var thinBold = "_ab-7";
export var vertical = "_ab-4";
export var xs = "_ab-1";